/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Open_TaskInputs */

const cs_signing_open_task = /** @type {(inputs: Signing_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít úkol`)
};

const en_signing_open_task = /** @type {(inputs: Signing_Open_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open task`)
};

/**
* | output |
* | --- |
* | "Open task" |
*
* @param {Signing_Open_TaskInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_open_task = /** @type {((inputs?: Signing_Open_TaskInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Open_TaskInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_open_task(inputs)
	return cs_signing_open_task(inputs)
});